import React, { useEffect, useState } from "react";

const TotalCheck = ({data}) => {

  const [productCount, setProductCount] = useState(0);
  const [supplyPrice, setSupplyPrice] = useState(0);
  const [surtax, setSurtax] = useState(0);

  const priceComma = (price) => {
    return price.toLocaleString('ko-KR', {maximumFractionDigits: 0})
  }

  const setData = (data) => {
    // console.log(data)
    data.forEach((e) => {
      if(Object.keys(e).length !== 0) {
        setProductCount((prev) => prev + e.count)
        setSupplyPrice((prev) => prev + e.supplyPrice)
        setSurtax((prev) => prev + e.surtax)
      }
    }) 
  }

  useEffect(() => {
    setData(data);
  }, [])

  return (
    <div className="flex text-right mt-1 border-black border-2 justify-between min-w-full">
      <StyledDiv text={"수량"} />
      <StyledDiv text={priceComma(productCount)} style={"flex-grow"}/>
      <StyledDiv text={"공급가액"} />
      <StyledDiv text={priceComma(supplyPrice)} style={"flex-grow"}/>
      <StyledDiv text={"VAT"} />
      <StyledDiv text={priceComma(surtax)} style={"flex-grow"}/>
      <StyledDiv text={"합계"} />
      <StyledDiv text={priceComma(supplyPrice + surtax)} style={"flex-grow"}/>
      <StyledDiv text={"인수"} />
      <StyledDiv text={"  인"} style={"flex-grow"}/>
    </div>
  )
}

const StyledDiv = ({text, style}) => {
  return (
    <div className={`border px-1 border-black ${style}`}>{text}</div>
  )
}

export default TotalCheck;

